import { render, staticRenderFns } from "./DashboardSMAZoneChairman.vue?vue&type=template&id=1f5b6514"
import script from "./DashboardSMAZoneChairman.vue?vue&type=script&lang=js"
export * from "./DashboardSMAZoneChairman.vue?vue&type=script&lang=js"
import style0 from "./DashboardSMAZoneChairman.vue?vue&type=style&index=0&id=1f5b6514&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports